import { gql } from "@apollo/client";

// The Logs tab: what admins changed, in the panel and signed in as users.
// Super admin only on the backend as well.
export const GET_ADMIN_LOG = gql`
  query adminLog(
    $adminId: Int
    $entityType: String
    $limit: Int
    $offset: Int
  ) {
    adminLog(
      adminId: $adminId
      entityType: $entityType
      limit: $limit
      offset: $offset
    ) {
      id
      adminId
      adminEmail
      entityType
      action
      entityId
      userId
      userEmail
      sessionId
      operation
      changes {
        subject
        detail
      }
      success
      error
      ip
      createdAt
    }
  }
`;

export const GET_ADMIN_LOG_ADMINS = gql`
  query adminLogAdmins {
    adminLogAdmins {
      id
      email
    }
  }
`;
